module.exports = __webpack_public_path__ + "media/images/prichozi-c10a7def6408cbd09170afc962eb44b5.png";